import { NgModule } from '@angular/core';
import { LazyLoadImages } from './directives/lazy-load-images/lazy-load-images.directive';
import { NoRenderDirective } from './directives/no-render/no-render.directive';
import { CustomCurrencyLightPipe } from './pipes/custom-currency-light.pipe';
import { CustomCurrencyPipe } from './pipes/custom-currency.pipe';
import { SafePipe } from './pipes/safe.pipe';

@NgModule({
  declarations: [
    SafePipe,
    CustomCurrencyPipe,
    CustomCurrencyLightPipe,
    LazyLoadImages,
    NoRenderDirective,
  ],
  imports: [],
  exports: [
    SafePipe,
    CustomCurrencyPipe,
    CustomCurrencyLightPipe,
    LazyLoadImages,
    NoRenderDirective,
  ],
})
export class SharedModule {}
